<router-outlet></router-outlet>

<!-- Own markup so a toast never takes focus from what the user is doing. -->
<p-toast>
  <ng-template #headless let-closeFn="closeFn" let-message>
    <div class="p-toast-message-content app-toast">
      <i aria-hidden="true" class="material-symbols-outlined app-toast__icon">
        error
      </i>
      <span class="app-toast__text">{{ message.detail }}</span>
      <button
        class="p-toast-close-button"
        type="button"
        [attr.aria-label]="'TOAST.CLOSE' | transloco"
        (click)="closeFn($event)">
        <i aria-hidden="true" class="material-symbols-outlined">close</i>
      </button>
    </div>
  </ng-template>
</p-toast>

<p-confirmDialog></p-confirmDialog>
